import IntegrationItemIcon from './component'

export default IntegrationItemIcon
